// extracted by mini-css-extract-plugin
module.exports = {"Hero":"hero-module--Hero--fJNvc","Hero__container":"hero-module--Hero__container--1IHWU"};